import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import "./LoginSignup.css";
import * as utils from '../../global/utils';
import * as Helpers from '../../global/Helpers';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import i18next from 'i18next';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import OtpPopup from '../popups/OtpPopup/OtpPopup';
import * as Constants from "../../constants/Constants";
import * as actions from "../../store/actionTypes";
import * as AppUrls from "../../constants/AppUrls";
import { useSelector, useDispatch } from "react-redux";
import { LoginStatus } from "../../constants/Constants";
import { Redirect } from "react-router-dom";
import { Display } from "react-bootstrap-icons";
import InputMSX from '../InputMSX/InputMSX'
import { signal } from "@preact/signals-react";


export const otpSessionId  = signal("");

function SellIPOShares(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    let language = localStorage.getItem("language");
    if (language === null) {
        language = "en"
    }
    const [idNumber, setidNumber] = useState();
    const [mobileNumber, setmobileNumber] = useState();
    const [visible, setVisible] = useState(false);
    const [redirect, setRedirect] = useState(null);
    const [OmanAccBfx, setOmanAccBfx] = useState("");
    const [OmanAccAfx, setOmanAccAfx] = useState("");
    const [LanguageSelectedFromLogin, setLanguageSelected] = useState(language);
    const [isLanguageSelectedFromLogin, setIsLanguageSelectedFromLogin] = useState(false);
    const [numberPrefix, setNumberPrefix] = useState("");
    const [countries, setCountries] = useState([]);

    useEffect(() => {

        var DeviceConfigs = JSON.parse(localStorage.getItem("DeviceConfigs"));
        if (DeviceConfigs !== null && DeviceConfigs !== undefined) {
            setOmanAccBfx(DeviceConfigs.OmanAccBfx)
            setOmanAccAfx(DeviceConfigs.OmanAccAfx)


        } else {
            GetDeviceConfigs();
        }
    }, [])
    useEffect(() => {
        fetchCountries();
    }, [i18next.language]);

    function handleSubmit(e) {
        e.preventDefault();
        if (!validate()) {
            return
        }
        callUserAuthinticationIPOQuickSell();
    }

    function callUserAuthinticationIPOQuickSell() {

        setVisible(true);
        var MOB = numberPrefix + mobileNumber
        let response = utils.UserAuthinticationIPOQuickSell("IOS", "192.168.26.1", "", idNumber, MOB, "", "")

        response.then((response) => {

            setVisible(false);
            console.log("UserAuthinticationIPOQuickSell: ", response);

            // let status = response.data["Status"]
            // switch (status) {
            //     case Constants.LoginStatus.Success:
            //         localStorage.setItem("username", response.data["UserName"]);
            //         localStorage.setItem("WebCode", response.data["WebCode"]);
            //         otpPrompt();
            //         break;
            //     case "-1":
            //         Helpers.errorNotify(t("InvalidNINorMobileNo"), i18next.language)
            //         break;
            //     default:
            //         Helpers.errorNotify("error has occured", i18next.language)
            //         // Helpers.errorNotify(response.data["ErrorMsg"], i18next.language)
            //         break;
            // }


            var status = response.data["Status"]
            let isFirstLoggedIn = response.data["IsFirstLogin"];
            // if (isFirstLoggedIn === "Y") {

            //     localStorage.setItem("WebCode", response.data["WebCode"]);
            //     setRedirect(AppUrls.changePassword);
            //     return;
            // }

            if (status === null) {
                // errorNotify(t("somethingwentwrong"));
                Helpers.errorNotify(t("servicesIsDownMSG"), i18next.language);
                return;
            }

            switch (status) {
                case LoginStatus.Success:

                    if (isFirstLoggedIn === "Y") {
                        localStorage.setItem("loginFirst", true);
                        localStorage.setItem("WebCode", response.data["WebCode"]);
                        localStorage.setItem("ExpiredDocument", response.data["isExpiredDocument"]);
                        localStorage.setItem("isIndividual", response.data["isIndividual"]);
                        // localStorage.setItem("passwordToOTp", "false");
                      otpSessionId.value = "false";
                        localStorage.setItem("validValue", "");
                        localStorage.setItem("username", response.data["UserName"]);
                        localStorage.setItem("IsNormalLogin", false);
                        localStorage.setItem("isTermsAndConditions", response.data["isTermsAndConditions"]);

                        getUserSettings();
                        //  setRedirect(AppUrls.changePassword);

                        return;
                    } else {
                        localStorage.setItem("loginFirst", true);
                        Helpers.successNotify(t("loggedinsuccessfully"), i18next.language);
                        localStorage.setItem("user", JSON.stringify(response.data));
                        localStorage.setItem("username", response.data["UserName"]);
                        localStorage.setItem("WebCode", response.data["WebCode"]);
                        localStorage.setItem("ExpiredDocument", response.data["isExpiredDocument"]);
                        localStorage.setItem("isIndividual", response.data["isIndividual"]);
                        localStorage.setItem("IsNormalLogin", false);
                        // localStorage.setItem("isRememberMe", "" + isRememberMe);
                        getUserSettings();
                        localStorage.setItem("isTermsAndConditions", response.data["isTermsAndConditions"]);
                        getUserSettings();

                        // if (response.data["isTermsAndConditions"] === "N" && localStorage.getItem(Constants.localStorageConstants.Region).toUpperCase() === "OMAN") {
                        //     setRedirect(AppUrls.TermsAndConditions);
                        // }
                        // else {
                        setRedirect(AppUrls.trading);
                        // }

                    }

                    break;
                case LoginStatus.InvalidLogin:
                    Helpers.errorNotify(t("InvalidNINorMobileNo"), i18next.language);
                    break;
                case LoginStatus.invalidTokenID:
                    Helpers.errorNotify(t("invalidToken"), i18next.language);
                    break;
                case LoginStatus.TokenSent:
                    Helpers.successNotify(t("tokenSent"), i18next.language);
                    localStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("username", response.data["UserName"]);
                    // localStorage.setItem("passwordToOTp", "false");    
                         otpSessionId.value = "false";           
                    localStorage.setItem("isFirstLoggedIn", isFirstLoggedIn);
                    localStorage.setItem("ExpiredDocument", response.data["isExpiredDocument"]);
                    localStorage.setItem("isIndividual", response.data["isIndividual"]);
                    localStorage.setItem("IsNormalLogin", false);
                    localStorage.setItem("isTermsAndConditions", response.data["isTermsAndConditions"]);
                    setRedirect(AppUrls.otp);
                    break;
                case LoginStatus.TokenExpire:
                    Helpers.errorNotify(t("tokenExpire"), i18next.language);
                    break;
                case LoginStatus.noPermetions:
                    Helpers.errorNotify(t("nopermissions"), i18next.language);
                    break;
                case LoginStatus.ExceedNoTrials:
                    Helpers.errorNotify(t("userLocked"), i18next.language);
                    break;
                // case LoginStatus.AlreadyLoggedIn: //Case: Already logged in
                //     alreadyLoggedInFunc();
                //     break;
                case LoginStatus.NotAgreeTermCondtion:
                    Helpers.errorNotify(t("notAgreeTermCondtion"), i18next.language);
                    break;
                case LoginStatus.UnknowError:
                    Helpers.errorNotify(t("somethingwentwrong"), i18next.language);
                    break;
                case LoginStatus.IPOQuickSell:
                    Helpers.errorNotify(t("pleaseContactAdminstrator"), i18next.language);
                    break;

                default:
                    var message = t("somethingwentwrong");
                    if (response.data["ErrorMsg"])
                        Helpers.errorNotify(message, i18next.language);
                    break;
            }
        })
            .catch((error) => {
                setVisible(false);
                console.log("error", error);
                Helpers.errorNotify(error.message, i18next.language);
            });
    }

    if (redirect !== null) {
        return <Redirect to={redirect} />;
    }


    function validate() {

        if (idNumber === "" || idNumber === null || idNumber === undefined) {
            Helpers.errorNotify(t("Trading_Number_is_required"), i18next.language)
            return false;
        }

        if (mobileNumber === "" || mobileNumber === null || mobileNumber === undefined) {
            Helpers.errorNotify(t("mobileRequired"), i18next.language)
            return false;
        }
        if (numberPrefix === null || numberPrefix === "") {
            Helpers.errorNotify(t("mobileRequired"), i18next.language);
            return false
        }

        return true;
    }


    const getUserSettings = () => {

        let response = utils.GetSettingWorkSpaceByUserID();
        response.then((response) => {
            let data = response.data[0]

            if (data.WorkSpaceSettings !== undefined && data.WorkSpaceSettings !== null && data.WorkSpaceSettings !== "") {

                var res = JSON.parse(data.WorkSpaceSettings);
                localStorage.setItem("selectedProfile", res.selectedProfile);
                localStorage.setItem("theme", res.theme)
                localStorage.setItem("UserSettings", data.WorkSpaceSettings);

                dispatch({
                    type: actions.SELECT_PREFERRED_SYMBOL,
                    payload: {
                        PreferredSymbol: res.PreferredSymbol
                    }
                })

                dispatch({
                    type: actions.SELECT_PREFERRED_EXCHANGE,
                    payload: {
                        PreferredExchange: res.PreferredExchange
                    }
                })

                dispatch({
                    type: actions.UPDATE_ENABLE_EXPAND_ROW,
                    payload: {
                        EnableExpandRow: res.expandRow === "Y" ? true : false
                    }
                })

                dispatch({
                    type: actions.ENABLE_TRADE_TICKER,
                    payload: {
                        EnableTradeTicker: res.tradeTicker === "Y" ? true : false
                    }
                })

                dispatch({
                    type: actions.ENABLE_ROUND_TICKER,
                    payload: {
                        EnableRoundTicker: res.RoundTicker === "Y" ? true : false
                    }
                })


                saveSettings(data);
            }
        }).catch((error) => {

            console.log("error", error);
        });
    }

    function saveSettings(data) {
        var res = JSON.parse(data.WorkSpaceSettings);
        let LanguageSelectedFromLogin = localStorage.getItem(
            "LanguageSelectedFromLogin"
        );
        let isLanguageSelectedFromLogin = localStorage.getItem(
            "isLanguageSelectedFromLogin"
        );
        var lang = "";
        if (isLanguageSelectedFromLogin === "true") lang = LanguageSelectedFromLogin;
        else lang = res.lang;
        let settings = {
            lang: lang,
            theme: res.theme,
            //theme: '',
            expandRow: res.expandRow,
            PreferredSymbol: res.PreferredSymbol,
            PreferredExchange: res.PreferredExchange,
            selectedProfile: res.selectedProfile,
            tradeTicker: res.tradeTicker,
            RoundTicker: res.RoundTicker,
        };

        if (data !== undefined && data !== null) {
            let postdata = {
                profileUniqueID: data.profileUniqueID,
                ProfileID: data.ProfileID,
                ProfileName: data.ProfileName,
                ProfileNameAr: data.ProfileNameAr,
                ProfileSettings: data.ProfileSettings,
                WorkSpaceSettings: JSON.stringify(settings),
                WebCode: localStorage.getItem("WebCode"),
            };
            var updateWorkSpaceSettings = utils.UpdateUserProfileSettings(postdata);
            updateWorkSpaceSettings
                .then((response) => {
                    if (response.data) {
                        // console.log("Settings Successfully Updated");
                        // this.props.setUserSettings(settings)
                        localStorage.setItem("UserSettings", JSON.stringify(settings));

                        if (i18next.language === "ar" && settings.lang === "en")
                            props.changeLanguageNew();
                        else if (i18next.language === "en" && settings.lang === "ar")
                            props.changeLanguageNew();
                    } else {
                        console.log(
                            "Unsuccessfull Update Settings, please contact Administrator"
                        );
                    }
                })
                .finally(() => {

                })
                .catch((error) => {
                    console.log(
                        "Unsuccessfull Update Settings, please contact Administrator"
                    );

                });
        }
    }

    const GetDeviceConfigs = () => {

        let getProfilesByUserIdResponse = utils.GetDeviceConfigs();
        getProfilesByUserIdResponse
            .then(response => response.data)
            .then(data => {
                localStorage.setItem("ForgotPasswordMethod", data.ForgotPasswordMethod);
                localStorage.setItem("DeviceConfigs", JSON.stringify(data));
                setOmanAccBfx(data.OmanAccBfx)
                setOmanAccAfx(data.OmanAccAfx)
            })
            .catch(error => {
                console.log(error);
            });


    }

    const handleChange1 = (event) => {

        let inputValue = event.target.value;
        inputValue = inputValue.replace(/[^0-9]/g, '').substring(0, 9);
        setidNumber(inputValue)

    };

    const handleBlur = () => {

        if (idNumber !== '' && idNumber !== undefined && idNumber !== null) {
            var Bfx = idNumber.substring(0, 5);
            var Afx = idNumber.slice(-2);
            if (Bfx === OmanAccBfx && Afx === OmanAccAfx) {
                if (idNumber.includes(Bfx) && idNumber.includes(Afx)) {
                    const formattedValue = idNumber.padStart(9, '0')
                    setidNumber(formattedValue)
                } else {
                    const formattedValue = OmanAccBfx + idNumber.padStart(9, '0') + OmanAccAfx;
                    setidNumber(formattedValue)
                }
            } else {
                const formattedValue = OmanAccBfx + idNumber.padStart(9, '0') + OmanAccAfx;
                setidNumber(formattedValue)
            }

        }
    };

    function changeLanguageNew(e) {

        e.preventDefault();
        var newlang = "";
        if (LanguageSelectedFromLogin === "en") {
            newlang = "ar";
        } else {
            newlang = "en";
        }
        setLanguageSelected(newlang);
        setIsLanguageSelectedFromLogin(true);
        localStorage.removeItem("LanguageSelectedFromLogin");
        localStorage.removeItem("isLanguageSelectedFromLogin");
        localStorage.setItem("LanguageSelectedFromLogin", newlang);
        localStorage.setItem("isLanguageSelectedFromLogin", true);
        props.changeLanguageNew();



    };

    const callLogOff = () => {
        // 
        // props.setIsLoaderVisible(true);
        //console.log("logging out...");
        let logOffResponse = utils.logOff();
        logOffResponse
            .then((response) => {
                // props.setIsLoaderVisible(false);
                //console.log("Logged Off", response)
                if (response.status === 200) {
                    localStorage.removeItem("user");
                    localStorage.removeItem("ExpiredDocument");
                    let UserName = localStorage.getItem("username");
                    let RememberMe = localStorage.getItem("isRememberMe");
                    let language = localStorage.getItem("language");

                    let Comapnyname = localStorage.getItem(
                        Constants.localStorageConstants.company_name
                    );
                    var prev = Helpers.getPreviousConfig();
                    if (RememberMe === "true") {
                        localStorage.clear();
                        localStorage.setItem("isRememberMe", true);
                        localStorage.setItem("username", UserName);
                        localStorage.setItem("language", language);

                        localStorage.setItem(
                            Constants.localStorageConstants.company_name,
                            Comapnyname
                        );
                    } else {
                        localStorage.clear();
                        localStorage.setItem("language", language);

                        localStorage.setItem(
                            Constants.localStorageConstants.company_name,
                            Comapnyname
                        );
                    }
                    Helpers.SetpreviosConfig(prev);
                    setRedirect(AppUrls.login);
                    //   setState({ redirect: AppUrls.login }, () => {
                    //     disconnectSignalr();
                    //   });
                }
            })
            .catch((error) => {
                //props.setIsLoaderVisible(false);
                //console.log("error", error);
            });
    };

    let localizationBtnClass = "mt-2 mr-2";
    let localizationBtnFloat = "right";
    if (i18next.language === "ar") {
        localizationBtnClass = "mt-2 ml-2";
        localizationBtnFloat = "left";
    }

    const fetchCountries = async () => {
        try {
            const params = {
                Lang: i18next.language === "ar" ? "AR" : "EN"
            };
            var response = utils.CountriesLookupAPI(params);
            await response
                .then((response) => {

                    if (response.data.ErrorMsg === "success") {

                        const sortedCountries = response.data.resData.sort((a, b) => {
                            if (a.countryName < b.countryName) return -1;
                            if (a.countryName > b.countryName) return 1;
                            return 0;
                        });
                        setCountries(sortedCountries);

                        // Directly default to +968
                        const defaultCountry = sortedCountries.find(
                            (country) => country.PhoneCode === "+968"
                        );
                        if (defaultCountry) {
                            setNumberPrefix(defaultCountry.PhoneCode.substring(1));
                        } else if (sortedCountries.length > 0) {
                            setNumberPrefix(sortedCountries[0].PhoneCode.substring(1));
                        }
                    } else {
                        Helpers.errorNotify(response.data.ErrorMsg, i18next.language);

                    }
                })
                .catch((error) => {
                    console.log('fetchCountriesApi', error);
                });
        } catch (error) {
            console.log('fetchCountries', error);
        }
    }
    return (
        <>
            {/* <input
                className="input-textbox"
                type="text"
                name="idNumber"
                // placeholder={t("TradingNumber")}
                placeholder={OmanAccBfx + "XXXXXXXXX" + OmanAccAfx}
                value={idNumber}
                onChange={(e) => setidNumber(e.target.value)}
            /> */}
            {
                Helpers.getIsIPad() || (localStorage.getItem(Constants.localStorageConstants.company_name) === "HORIZONd" )? <input
                    className="form-control"
                    type="text"
                    pattern={Helpers.getIsIPad() ? "\\d*" : null}
                    inputMode={Helpers.getIsIPad() ? "numeric" : null}
                    value={idNumber}
                    onChange={handleChange1}
                    onBlur={handleBlur}
                    maxLength={9}
                    placeholder={OmanAccBfx + "XXXXXXXXX" + OmanAccAfx}
                /> :
                    <InputMSX
                        value={idNumber}
                        placeholder={OmanAccBfx + "XXXXXXXXX" + OmanAccAfx}
                        onChange={(e) => setidNumber(e)}
                        mask={OmanAccBfx + "999999999" + OmanAccAfx}
                    />
            }
            {/* <input
                className="input-textbox"
                type="text"
                name="mobileNumber"
                placeholder={t("mobileNo")}
                value={mobileNumber}
                onChange={(e) => setmobileNumber(e.target.value)}
            /> */}

            <div className="form-group">
                <div className="input-group">
                    <select
                        id="country"
                        value={numberPrefix}
                        onChange={(e) => setNumberPrefix(e.target.value)}
                        className="form-control"
                        style={{
                            width: '30%',
                            borderBottom: '1px solid lightgray !important',
                            borderLleft: '0px',
                            borderRight: '1px solid lightgray !important',
                            borderTop: '0px',
                            marginTop: '10px',
                            height: '35px'
                        }}
                    >
                        {countries.map((country, index) => (
                            <option
                                key={index}
                                value={country.PhoneCode.substring(1)}
                            >
                                {country.countryName + country.PhoneCode}
                            </option>
                        ))}
                    </select>
                    <input
                        className="input-textbox"
                        type="text"
                        name="mobileNumber"
                        placeholder={t("mobileNo")}
                        value={mobileNumber}
                        onChange={(e) => setmobileNumber(e.target.value)}

                        style={{ width: "70%" }}
                    />


                </div>
            </div>
            <button
                className="form-group form-group-btns auth-btns btn btn-primary customBtn " id="IPOQuick"
                style={{ width: "100%" }}
                onClick={(e) => handleSubmit(e)}
                type='submit'
            >
                {t("Login")}
            </button>

            <button
                className={"link WelcomeMessageDiv" }
                style={{
                    marginLeft: "auto",
                    marginRight: "auto",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    display: (localStorage.getItem(Constants.localStorageConstants.company_name) === "HORIZON") ? "block" : "block"
                }}
                onClick={
                    (event) => {
                        event.preventDefault();
                        callLogOff();
                        setRedirect(AppUrls.login);
                        //   localStorage.getItem(Constants.localStorageConstants.company_name) === "CIBC" ? setRedirect(AppUrls.loginCIBC) : setRedirect(AppUrls.login);

                    }}
            >
                {t("cancelForgotPassword")}
            </button>

            <div className={localizationBtnClass + " langBtn"} style={{ float: localizationBtnFloat }}>
                <button
                    tabIndex="8"
                    className="language-btn mr"
                    type='button'
                    onClick={(e) => changeLanguageNew(e)}
                    disabled={visible}
                >
                    <i className="fa fa-language language-icon " aria-hidden="true"></i>
                    <div className="language-btn-text">{t("localizationLanguage")}</div>
                </button>
            </div>

        </>
    )
}

export default SellIPOShares
